module.exports = __webpack_public_path__ + "img/reports-bas.dcb007c3.svg";